<template>
  <div>
    <fieldset class="border p-3">
      <legend >
        <small style="font-size:15px; font-weight: bold">update role</small>
      </legend>
      <div>
        <form @submit.prevent="RoleUpdate()">
         <input type='hidden' :value="systemRole.id" class="roleId">
          <div class="form-group">
            <label>role name</label>
            <input type="text" class="form-control rolename" placeholder="rolename" :value="systemRole.role_name" required />
          </div>
          <div class="form-group">
            <label>slug</label>
            <input type="text" class="form-control roleSlug" placeholder="slug" :value="systemRole.role_slug" required />
          </div>
          <button type="submit" class="btn btn-primary btn-flat  updateRole">
            <i class="fa fa-refresh"></i> update role
          </button>
          <button type="button" class="btn btn-info btn-flat updateRoleLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index"

export default {

created() {
   if (this.$store.getters.systemRole.length === 0) {
      router.push('/managerole') 
   }
   
},
computed: {
    ...mapGetters (["systemRole"])
},
methods: {
    ...mapActions(["RoleUpdate"])
  }
};
</script>
<style scoped>
.updateRoleLoader{
  display: none
}
</style>


// WEBPACK FOOTER //
// src/roles/updaterole.vue